import { MaskAccountNumberPipe } from '../../../../../../../_helpers/_pipes/mask-account-number.pipe';
import { MapfreLoadingComponent } from '../../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { AttentionInfoComponent } from '../../../../attention-info/attention-info.component';
import { ImpNoticeComponent } from '../../../../imp-notice/imp-notice.component';
import { MapfreButtonComponent } from '../../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule, DatePipe, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router, Params, RouterModule } from '@angular/router';
import { AcmicService, AlertService } from '@mapfre-design-library/src/public_api';
import { BillingDataService } from '../../../../../../../_services/data-services/billing-data.service';
import { ActivatedRoute } from '@angular/router';
import { PaperlessService } from '../../../../../../../_services/_iam/paperless.service';
import { EnrollEftEpayService } from '../../../../../../../_services/forms/enroll-eft-epay/enroll-eft-epay.service';
import { PolicyDataService } from '../../../../../../../_services/data-services/policy-data.service';
import { Constants } from '@models/constants';
import { SortPipe } from '../../../../../../../_helpers/_pipes/sort.pipe';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent, ImpNoticeComponent, AttentionInfoComponent, MapfreLoadingComponent, MaskAccountNumberPipe],
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  providers: [SortPipe, DatePipe, CurrencyPipe],
})
export class PaperlessPayConfirmComponent implements OnInit {
  billingInfo: any;
  policyId: string;
  policyType: string;
  accountType: string;
  bankAccountNumber: string
  prevousRoute = '';
  billedInvoice = false;
  plannedWithdrawalDate: string;
  billedWithdrawalDate: string;
  importantText: string;
  attentionText: string;
  minAmountDue: string;
  loading = true;
  oldConfirmScreen = false;
  isAcmic = false;
  plannedBills;
  isLegacyPolicy: boolean;
  backIcon: string;
  company = '';
  currTime = '';
  currDate = '';
  isTWRecurringCCDC = false;

  constructor(
    private alertService: AlertService,
    private billingDataService: BillingDataService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private paperlessService: PaperlessService,
    private enrollEftEpayService: EnrollEftEpayService,
    private policyDataService: PolicyDataService,
    private datePipe: DatePipe, private sort: SortPipe,
    private acmicService: AcmicService,
    private currencyPipe: CurrencyPipe,
  ) {
    this.plannedBills = [];
  }

  reSyncBilling(): void {
    this.paperlessService.setCurrentRoute('');
    if (this.prevousRoute == '') {
      this.prevousRoute = `/my-insurance/${this.policyId}/billing`;
    }
    this.router.navigateByUrl(this.prevousRoute);
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.setFormattedDateTime();
    this.backIcon = this.isAcmic
      ? 'assets/img/images/back-arrow-blue-005095.svg'
      : 'assets/img/images/back-arrow-red.svg';
    this.billingDataService.$billingDetails.subscribe((success) => {
      this.billingInfo = success;
      if (this.billingInfo?.bankAccount?.accountNumber?.digits) {
        this.bankAccountNumber = this.billingInfo?.bankAccount?.accountNumber?.digits;
        this.bankAccountNumber = this.bankAccountNumber.slice(-4).padStart(this.bankAccountNumber.length, '*')
      }
    });
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
    });
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      if (queryParams['mode'] === 'edit-confirm') {
        this.oldConfirmScreen = true;
      }
    });
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        policyResponse.filter((policy) => {
          if (policy.policynumber.policyNumber === this.policyId) {
            this.isLegacyPolicy = (policy?.company?.companyName === 'TW' || policy?.company?.companyName === 'ACIC');
            this.isTWRecurringCCDC = (policy?.company?.companyName === 'TW' && policy?.billingDetails[0]?.noticeType === 'RECURRING CC/DC')
            this.company = policy?.company?.companyName;
            this.policyType = policy?.displayType?.label?.toLowerCase();
            policy.scheduleBills.filter((scheduledBill) => {
              if (scheduledBill.invoiceState === 'Billed') {
                this.billedInvoice = true;
                this.billedWithdrawalDate = scheduledBill.dateDue;
                this.minAmountDue = scheduledBill.minAmountDue;
              }
            });
            this.plannedBills = policy.scheduleBills.filter(
              (scheduledBill) => scheduledBill.invoiceState === 'Planned'
            );
            const sortedPlannedBills = this.sort.transform(
              this.plannedBills,
              'dateDue',
              'asc'
            );
            if (sortedPlannedBills.length) {
              this.plannedWithdrawalDate = this.datePipe.transform(
                sortedPlannedBills[0].dateDue,
                Constants.DATE_MM_DD_YYYY
              );
              if (this.billedInvoice) {
                this.importantText = `Your first automatic payment is scheduled on <b>${this.plannedWithdrawalDate
                  }</b>. Your current amount due on <b>${this.datePipe.transform(
                    this.billedWithdrawalDate,
                    Constants.DATE_MM_DD_YYYY
                  )}</b> is <b>${this.currencyPipe.transform(this.minAmountDue)}</b>.`;

                this.attentionText = `You will need to make your next payment manually before autopay will begin.`;
              }
            }
          }
        });
        this.loading = false;
      }
    });
    if (this.policyId.length === 10) {
      if (this.billingInfo.bankAccount.accountType === 'CHECKINGL') {
        this.accountType = 'CHECKING';
      }
      if (this.billingInfo.bankAccount.accountType === 'SAVINGL') {
        this.accountType = 'SAVING';
      }
    } else {
      this.accountType = this.billingInfo?.bankAccount?.accountType;
    }

    this.prevousRoute = this.enrollEftEpayService.getPrevEftRoute();
  }

  setFormattedDateTime() {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/New_York',
      timeZoneName: 'short'
    })

    this.currTime = formatter.format(now).replace('AM', 'a.m.').replace('PM', 'p.m.');
    this.currDate = `${this.datePipe.transform(now, Constants.DATE_MM_DD_YYYY)}`
  }

  payNow() {
    this.router.navigate(['/billing', this.policyId, 'new-payment']);
  }
  navigateBack() {
    this.router.navigate(['/billing', 'autopay']);
  }
}
